<template>
  <div class="button" @click="disabled || $emit('click')" :class="{disabled: disabled}">
    {{ label }}
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    disabled: Boolean
  }
}
</script>

<style lang="scss" scoped>
.button{
  @include box(100%, 2.5vw, relative, null, null, null, null, 0.3vw, $button);
  @include flex(center, center, row);
  @include text(1vw, 400, null, null, center, $buttonLabel);
  @include border($buttonBorder, solid, null, null, null, null, 0.04vw);
  @include padding(1.5vw, 0, 1.5vw, 0);
  cursor: pointer;
  &:hover{
    @include box(null, null, null, null, null, null, null, null, $buttonHover);
    @include text(null, null, null, null, null, $buttonHoverLabel);
    transform: scale(0.99);
  }
  &.disabled{
    @include box(null, null, relative, null, null, null, null, null, $button);
    @include text(null, null, null, null, null, $buttonLabel);
    transform: scale(1);
    opacity: 0.5;
    cursor: default;
  }
}
</style>
